// extracted by mini-css-extract-plugin
export default {"news":"News_news__c0qN3","title":"News_title__081ur","carousel":"News_carousel__FDCMT"};